






































































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import { fmoney } from '@/common/money';
import { TbOrderPad } from '@/http';
import dayjs from "dayjs";
import calculate from '@/common/util/calculate';
import Bus from '@/common/util/bus';
import { Toast } from 'vant';
@Component({
    components: {
    },
})
export default class couponPop extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        type:Object,
        default:()=>{
          return {}
        }
    })
    form:any;
    @Prop({
        type:Object,
        default:()=>{
          return {}
        }
    })
    sdObj:any;

    /**已选中优惠券优惠金额 */
    @Prop({
        default:0
    })
    yhAmount:number;
    /**应收总额 */
    receivables=0
    @Prop({
      default:0
    })
    receivablesNew:number;
    /**已选中优惠券id */
    @Prop({
        default:""
    })
    activeId:String;

    gwList=[];

    /**会员信息 */
    @Prop({
        type:Object,
        default:()=>{
            return {
                balance:0
            }
        }
    })
    memberInfo:any;
  

    /**是否达到使用门槛 */
    canUse=true;
    /**优惠后总额 */
    totalAfterDiscount=0;
    /**优惠总额 */
    get discountAmount(){
        let val = 0;
        val = calculate.subtraction(this.receivables,this.totalAfterDiscount);
        return val;
    }

    userInfo:any={};


    fmoney = fmoney;

    
    created() {
      this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
      this.gwList = localStorage.getItem("gwByCoupon")?JSON.parse(localStorage.getItem("gwByCoupon")):[];
      // this.receivablesNew = localStorage.getItem("receivablesByCoupon")?Number(localStorage.getItem("receivablesByCoupon")):0;
       
    }   
    
    async mounted() {
     
      if(this.activeId){
          this.receivables = calculate.addition(this.receivablesNew,this.yhAmount);
          this.chargeMK(this.form.canUse);
      }else{
          this.receivables = this.receivablesNew;
          this.chargeMK(this.form.canUse);
      }
   
      // Bus.$on('resCalcCoupon',(res)=>{
      //       let arr = res.items.map(v=>v.finalPrice);
      //       if(arr.length>0){
      //           this.totalAfterDiscount = arr.reduce((a,b)=>calculate.addition(a,b));
      //       }
      //   })
    }

    async calcCoupon(sdObj){
        if(this.gwList.length==0) return;
        let wholeOrderDiscountPrice = 0;
        let memberDiscount = this.memberInfo.id?this.memberInfo.gradeDiscount==0&&!this.memberInfo.gradeId?1:calculate.division(this.memberInfo.gradeDiscount,10):1; 
        let arr = this.gwList.map(v=>v.isGift?0:v.isNoCode?calculate.multiplication(v.sellingPrice,v.num):v.discountPrice? calculate.multiplication(calculate.multiplication(v.discountPrice,v.isMemberDiscount?memberDiscount:1),v.num): calculate.multiplication(calculate.multiplication(v.sellingPrice,v.isMemberDiscount?memberDiscount:1),v.num));

        
        if(arr.length>0){
            wholeOrderDiscountPrice = arr.reduce((a,b)=>calculate.addition(a,b));
        }
        
        let obj = {
            shopId:this.userInfo.shopId,
            memberCouponId:this.form.id,
            isSingle:sdObj.isSingle,
            memberId:this.memberInfo.id?this.memberInfo.id:"",
            isWholeOrderDiscount:sdObj.isWholeOrderDiscount,
            wholeOrderDiscountPrice:sdObj.wholeOrderDiscountPrice,
            orderDiscount:sdObj.orderDiscount,
            isDeduction:sdObj.isDeduction,
            useIntegral:sdObj.useIntegral,
            pointDeduction:sdObj.pointDeduction,
            items:this.gwList.map(v=>{
                return{
                    shopId:v.shopId,
                    goodId:v.id,
                    goodsItemId:v.goodsItemId,
                    num:v.num,
                    articleNo:v.articleNo,
                    price:v.isNoCode?v.sellingPrice:0,
                    isGift:v.isGift,
                }
            })
        }
        // Toast(JSON.stringify(obj));
        let resOrder = await TbOrderPad.CalcOrderInfo(obj);
        let arr2 = resOrder.items.map(v=>v.finalPrice);
        if(arr2.length>0){
          this.totalAfterDiscount = arr2.reduce((a,b)=>calculate.addition(a,b));
        }
    }

    /**判断使用门槛 */
    chargeMK(item){
        this.canUse = item;
        if(this.canUse){
          this.$nextTick(async()=>{
            await this.calcCoupon(this.sdObj);
          })
        }
    }

    getThreshold(item){
      let str = "";
      switch (item.threshold) {
        case 0:
          str="无使用门槛"
          break;
        case 1:
          let money = fmoney(item.satisfiedQuantity)
          str="满"+money+'元可用';
          break;
        case 2:
          str="满"+item.satisfiedQuantity+'件可用';
          break;
       
      
        default:
          break;
      }
      return str;
    }
    getTimeType(item,item2,type='list'){
      let str,txt,connectUnit = "";
      if(type=='list'){
        txt='有效日期：';
        connectUnit = '-'
      }else{
        txt='有效期：';
        connectUnit = '至'
      }
      if(item.timeType==0){
        str=txt+"无使用期限"
      }else{
        let startTime = dayjs(item2.startTime).format("YYYY.MM.DD");
        let endTime = dayjs(item2.endTime).format("YYYY.MM.DD");
        str=txt+startTime+connectUnit+endTime;
      }
     
      return str;
    }

    getMk(item){
      let str = "";
      let extip=item.amount?`，最多优惠${fmoney(item.amount)}元`:''
      let extip2=item.amount?`，最多优惠${fmoney(item.amount)}元`:''
      if(item.method==0){
        switch (item.threshold) {
          case 0:
            str="使用门槛：无使用门槛"+extip;
            break;
          case 1:
            let satisfiedQuantity = fmoney(item.satisfiedQuantity)
            let amount = fmoney(item.amount)
            str=`使用门槛：订单满${satisfiedQuantity}元，减免${amount}元`;
            break;
          default:
            break;
        }
      }else if(item.method==1){
        switch (item.threshold) {
          case 0:
            str=`使用门槛：无使用门槛，享${item.discount}折`+extip;
            break;
          case 1:
            str=`使用门槛：订单满${fmoney(item.satisfiedQuantity)}元，享${item.discount}折`+extip2;
            break;
          default:
            break;
        }
      }
      return str;
    }
    getUseStore(item){
      let str ='';
      let num = item.details.filter(v=>v.dataType==1).length;
      let storeList = item.details.filter(v=>v.dataType==1).map(j=>j.dataName).join(';');
      str = `共${num}家：${storeList}`
      return str;
    }
    getProduct(item){
      let str = "";
      switch (item.goodsLimit) {
        case 0:
          str="全部商品适用"
          break;
        case 1:
          let num = item.details.filter(v=>v.dataType==2).length;
          str=`适用${num}款商品`
          break;
      
        default:
          break;
      }
      return str;
    }
    getUnuseProduct(item){
      let str ='';
      str = item.details.filter(v=>v.dataType==2).length
      return str;
    }

    closeFun(){
        this.$emit("closeFun");
    }
    chooseFun(){
      let obj = Object.assign({},this.form,{
            yhAmount:this.discountAmount,
        })
        this.$emit("confirmCoupon",obj);
        this.closeFun();
      }
      dmfClick(){
        // window.webkit.messageHandlers.getFocus.postMessage('getFocus');
      }
    chooseOther(){
        this.$emit("chooseOther");
        this.closeFun();
        this.$nextTick(()=>{
            Bus.$emit('watchCouponScan',true);
        })
        
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/couponPop.vue